import { BankAccount as BankAccountDetails, Currencies } from 'types/types'

export const getAccountNumber = (bankAccount: BankAccountDetails) => {
  switch (bankAccount?.currency) {
    case Currencies.EUR:
      return bankAccount?.options?.iban
    case Currencies.GBP:
      return bankAccount?.options?.ukAccountNumber
    case Currencies.USD:
    case Currencies.ZAR:
    case Currencies.NGN:
      return bankAccount?.options?.accountNumber
    default:
      return ''
  }
}

export const getBankCode = (bankAccount: BankAccountDetails) => {
  switch (bankAccount?.currency) {
    case Currencies.EUR:
      return bankAccount?.options?.bic
    case Currencies.GBP:
      return bankAccount?.options?.ukSortCode
    case Currencies.USD:
      return bankAccount?.options?.beneficiaryBank?.bic
    case Currencies.ZAR:
    case Currencies.NGN:
      return bankAccount?.options?.routingNumber
    default:
      return ''
  }
}
